import { Product } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { CreateVariantsFromTemplateFormValues } from "./types";

export type CreateVariantsFromTemplateFormContextType = {
  handleOnSubmit: (
    values: CreateVariantsFromTemplateFormValues
  ) => Promise<void>;
};

export const CreateVariantsFromTemplateFormContext = React.createContext<
  CreateVariantsFromTemplateFormContextType | undefined
>(undefined);
